import { render, staticRenderFns } from "./FormRadioButton.vue?vue&type=template&id=5ab5f6d2&scoped=true"
import script from "./FormRadioButton.vue?vue&type=script&lang=js"
export * from "./FormRadioButton.vue?vue&type=script&lang=js"
import style0 from "./FormRadioButton.vue?vue&type=style&index=0&id=5ab5f6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5f6d2",
  null
  
)

export default component.exports